/** Canonical JLPT order (beginner → advanced). */
export const JLPT_LEVEL_CODES = ["N5", "N4", "N3", "N2", "N1", "JFT A2"] as const;
export type JlptLevelCode = (typeof JLPT_LEVEL_CODES)[number];

export function parseMockTestLevelField(
  level: string | null | undefined,
): string[] {
  if (!level?.trim()) return [];
  return level
    .split(",")
    .map((s) => s.trim().toUpperCase())
    .filter(Boolean);
}

/** Dedupe and order by JLPT progression; join for API / DB. */
export function joinMockTestLevels(selected: string[]): string {
  const uniq = [...new Set(selected.map((s) => s.trim()).filter(Boolean))];
  uniq.sort((a, b) => {
    const ia = JLPT_LEVEL_CODES.indexOf(a as JlptLevelCode);
    const ib = JLPT_LEVEL_CODES.indexOf(b as JlptLevelCode);
    return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
  });
  return uniq.join(",");
}

export function formatMockTestLevelsForDisplay(
  level: string | null | undefined,
): string {
  const parts = parseMockTestLevelField(level);
  return parts.length ? parts.join(" · ") : level?.trim() || "-";
}
